import { Text } from "@react-email/components";
import { Layout, StyledButton } from "./components";

/**
 * @param {string} name name of person who submitted the contact form
 */
export default function ContactResponse({
	name,
	promo = false,
	promoCode = "",
}) {
	const utm_campaign = "contact_response";
	return (
		<Layout
			utm_campaign={utm_campaign}
			preview={`Thank you for contacting us ${name}!`}
		>
			{promo ? (
				<>
					<h1>10% OFF DISCOUNT CODE</h1>
					<Text
						style={{
							fontSize: "18px",
							fontWeight: "bold",
							color: "#bf2228",
							padding: "20px",
							borderWidth: 2,
							borderStyle: "dashed",
							borderColor: "#bf2228",
						}}
					>
						{promoCode}
					</Text>
				</>
			) : (
				<>
					<h3>Thank you for contacting us!</h3>
					<Text>
						We received your message, and one of our team members will be in
						touch with you as soon as possible.
					</Text>
					<Text>
						In the meantime, feel free to go back to our website and learn more
						about what we have to offer.
					</Text>
					<Text>
						Thank you again for considering us for your needs. We look forward
						to the opportunity to serve you.
					</Text>
				</>
			)}
			<br />
			<StyledButton
				link={`https://offcutshades.com/?utm_source=body&utm_medium=email&utm_campaign=${utm_campaign}&utm_id=ATemails`}
				text="Go back to our website"
			/>
		</Layout>
	);
}
